(() => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const dataNode = root.querySelector('[data-product-data]');
  if (!dataNode) return;
  let data;
  try { data = JSON.parse(dataNode.textContent); } catch { return; }
  const variantSelect = root.querySelector('[data-variant]');
  const planSelect = root.querySelector('[data-selling-plan]');
  const image = root.querySelector('#ProductMainImage');
  const button = root.querySelector('[data-add]');
  function showImage(src, alt) {
    if (!image || !src) return;
    image.removeAttribute('srcset'); image.src = src;
    if (alt) image.alt = alt;
  }
  function updatePrice() {
    const variant = data.variants.find(v => String(v.id) === variantSelect.value);
    if (!variant) return;
    const plan = variant.plans.find(p => String(p.id) === planSelect?.value);
    root.querySelector('[data-price]').textContent = plan ? plan.money : variant.money;
    const compare = root.querySelector('[data-compare]');
    compare.textContent = variant.compareMoney;
    compare.hidden = !!plan || !(variant.compare > variant.price);
    const description = root.querySelector('[data-plan-description]');
    if (description) description.textContent = plan ? plan.description : '';
    const canBuy = variant.available && (!data.requiresPlan || !!plan);
    button.disabled = !canBuy;
    button.textContent = canBuy ? 'カートに入れる' : '現在購入できません';
  }
  function updateVariant(changeImage) {
    const variant = data.variants.find(v => String(v.id) === variantSelect.value);
    if (!variant) return;
    if (planSelect) {
      const old = planSelect.value;
      const options = [];
      if (!data.requiresPlan) options.push(new Option('通常購入', ''));
      for (const plan of variant.plans) options.push(new Option(plan.name, String(plan.id)));
      planSelect.replaceChildren(...options);
      if (options.some(o => o.value === old)) planSelect.value = old;
    }
    if (changeImage && variant.image) showImage(variant.image);
    updatePrice();
  }
  variantSelect.addEventListener('change', () => updateVariant(true));
  planSelect?.addEventListener('change', updatePrice);
  root.querySelectorAll('[data-gallery-image]').forEach(b => b.addEventListener('click', () => showImage(b.dataset.galleryImage,b.dataset.galleryAlt)));
  updateVariant(false);
})();
